import React from 'react';
import { getAttr } from './Row';
import { button_style } from './NormalComponents';
import { warn_message_style, message_style_second } from '../common/Common_styles';

const SpecialComponents = (props) => {

  return (
    renderSpecialComponents(props)
  )
}

const renderSpecialComponents = (props) => {
  const {attr, layout, components, col, fillRemainCol} = props
  
  if (layout==='slide') {
    return (
      <p> {layout} 은 정의되지 않은 Layout입니다. </p>
    )
  }
  return renderSpecialComponents_default(props)
}

const renderSpecialComponents_default = (props) => {
  const {attr, layout, components, col, fillRemainCol} = props
  
  const getAttr_result = getAttr(attr)
  // console.log('getAttr_result.child : "'+ getAttr_result.child + '"');
  switch(getAttr_result.child) {
    case "TEL":
      return components.map(component => (
        <div className="chat_service_board_cpnt">
          {render_specialDescription(component.value)}
          <button className="chat_service_board_cpnt" style={button_style}>
            {component.name ? component.name : "연락처 입력"}          
          </button>
        </div>
      ))
    case "DATE":
      return components.map(component => (
        <div className="chat_service_board_cpnt">
          {render_specialDescription(component.value)}
          <button className="chat_service_board_cpnt" style={button_style}>
            {component.name ? component.name : "날짜 입력"}
          </button>
        </div>
      ))
    case "ADDR":
      return components.map(component => (
        <div className="chat_service_board_cpnt">
          {render_specialDescription(component.value)}
          <button className="chat_service_board_cpnt" style={button_style}>
            {component.name ? component.name : "주소 입력"}
          </button>
        </div>
      )) 
      
    default:
      return (
        <p> {getAttr_result.child}은 정의되지 않은 컴포넌트 타입 </p>
      )
  }
}

const render_specialDescription = (value) => {
  if (!!value === false) {
    if (value.trim() === "") {
      return (
        <p></p>
      )
      // return (
      //   <React.Fragment>
      //     <h4 style={warn_message_style}> 설명이 입력되지 않음 </h4>
      //     <p style={message_style_second}> 입력되지 않았을 경우 아무런 텍스트도 표시되지 않습니다. </p>  
      //   </React.Fragment>
      // )
    }
  }
  return (
    <p> {value} </p>
  )
}

export default SpecialComponents